import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { DownloadIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CTASection() {
  return <section id="cta-section" className="py-24 bg-white relative overflow-hidden" data-id="element-1">
      <div className="absolute inset-0 bg-[#4A6741] opacity-[0.03] pointer-events-none" data-id="element-2"></div>

      <div className="container mx-auto px-6 max-w-4xl text-center relative z-10" data-id="element-3">
        <FadeIn data-id="element-4">
          <div className="inline-block mb-6 px-4 py-1.5 bg-[#E8EDE6] text-[#4A6741] font-bold rounded-full text-sm tracking-wider uppercase" data-id="element-5">
            Oferta Especial
          </div>

          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-6">
            <span className="text-2xl md:text-3xl text-[#6B6560]/60 line-through decoration-2 font-serif" data-id="element-7">
              19.99€
            </span>
            <span className="text-5xl md:text-6xl font-bold text-[#2D2A26] font-serif" data-id="element-8">
              6.36€
            </span>
            <motion.div initial={{
            scale: 0,
            rotate: -12
          }} whileInView={{
            scale: 1,
            rotate: -6
          }} viewport={{
            once: true
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 15,
            delay: 0.3
          }} className="bg-[#B8963E] text-white font-bold text-sm md:text-base px-3 py-1.5 rounded-lg shadow-md -mt-6" data-id="element-9">
              -68%
            </motion.div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-2 font-serif" data-id="element-10">
            ACCESO INMEDIATO
          </h2>
          <p className="text-xl text-[#6B6560] mb-10" data-id="element-11">
            Empieza tu reseteo enzimático hoy mismo.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-12">
          <div className="max-w-md mx-auto" data-id="element-13">
            <Button fullWidth className="text-xl py-5 flex items-center justify-center gap-3" data-id="element-14">
              QUIERO MI PROTOCOLO AHORA
              <DownloadIcon className="w-5 h-5" data-id="element-15" />
            </Button>

            <div className="mt-6 flex flex-col items-center gap-2 text-sm text-[#6B6560]" data-id="element-16">
              <div className="flex items-center gap-2" data-id="element-17">
                <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-18">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-19"></path>
                </svg>
                <span data-id="element-20">Pago seguro.</span>
              </div>
              <p data-id="element-21">Recibe el acceso a tu PDF al instante en tu email.</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}